import { changelog } from '../generated/changelog';

export interface ChangelogEntry {
  version: string;
  date: string;
  changes: string[];
}

export function getChangelog(): ChangelogEntry[] {
  return changelog;
}

// Current version is the first (latest) entry in the changelog
export function getAppVersion(): string {
  return changelog.length > 0 ? changelog[0].version : '0.0';
}

export function getLatestChangelog(): ChangelogEntry | undefined {
  return changelog[0];
}

export function getChangelogForVersion(version: string): ChangelogEntry | undefined {
  return changelog.find((entry) => entry.version === version);
}
